//系统内置指标样式5：教师活动情况分析
<template>
    <div class="indicator-container">
        <ListHeader title="教师活动情况分析" />
        <div class="indicator-content">
            <div class="score-box">
              <Score :score="data.score" :max-score="data.maxScore"/>
            </div>
            <div class="divider"></div>
            <div class="text-box">

              {{data.remark}}
                <!-- 教师在整节课中始终围绕“名字里的故事
                ”这一核心教学内容，结合教材意图和课
                后练习要求，设定了清晰、具体、可操作
                的教学目标。例如，在导入阶段
                (00:26-05:12)，教师通过引导学生猜测
                自己的名字由来，激发学生的表达动机，
                并自然过渡到学习如何讲述自己... -->
            </div>
            <div class="divider"></div>
            <div class="chart-box">
                <div class="video-box">
                    <div class="video">
                        <img :src="image_url"/>
                    </div>

                    <div id="pie-chart" class="pie-chart">

                    </div>
                </div>
                <div class="line-chart-container">
                    <div id="line-chart" class="line-chart">
                    </div>
                    <!-- 添加箭头元素 -->
                    <!-- <div id="chart-arrow" class="chart-arrow">
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import ListHeader from '@/components/ListHeader.vue';
import Score from './Score.vue';
import * as echarts from 'echarts';
export default {
    name: 'SysStyle5',
    components: {
        ListHeader,
        Score,
    },

  props: {
    data: {
      type: Object,
      default: null
    },
  },
    data() {
        return {
            lineChart: null,
            pieChart1: null,
            segments: [],
            image_url:'',
        };
    },
    computed: {
        parsedExtra() {
            try {
                return JSON.parse(this.data?.extra || '{}').position_analysis || {};
            } catch (e) {
                console.warn('解析extra数据失败:', e);
                return {};
            }
        }
    },
    mounted() {
        // 确保DOM完全渲染后再初始化图表
        this.$nextTick(() => {
            this.initPieChart1();
            this.renderLineChart();
            this.renderImage();
        });
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        if (this.pieChart1) {
            this.pieChart1.dispose();
            this.pieChart1 = null;
        }
        if (this.lineChart) {
            this.lineChart.dispose();
            this.lineChart = null;
        }
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        initPieChart1() {
            // 获取图表容器
            const chartContainer = document.getElementById('pie-chart');
            if (chartContainer) {
                // 设置图表容器高度和宽度
                chartContainer.style.width = '100%';
                chartContainer.style.height = '100%';
                // 初始化图表
                this.pieChart1 = echarts.init(chartContainer);
                // 渲染图表
                this.renderPieChart1();
            } else {
                console.error('Pie Chart 1 container not found');
            }
        },
        renderPieChart1() {
            // Mock数据 - 饼图1数据
            // const mockData = [
            //     { value: 55, name: '讲台区域占比' },
            //     { value: 45, name: '学生区域占比' },
            // ];

            const extra = this.parsedExtra;

            const mockData = [
                { value: extra?.region_percentages?.platform_area?.percentage || 0, name: '讲台区域占比' },
                { value: extra?.region_percentages?.students_area?.percentage || 0, name: '学生区域占比' },
                { value: extra?.region_percentages?.other_area?.percentage || 0, name: '其它区域占比' },
            ];
            console.log('mockData is :',mockData);


            // 图表配置 - 左边饼图，右边图例
            const option = {
                tooltip: {
                    trigger: 'item',
                    backgroundColor: 'rgba(0, 28, 53, 0.8)',
                    borderColor: '#0585F7',
                    borderWidth: 1,
                    textStyle: {
                        color: '#FFF'
                    },
                    formatter: '{b}: {c}% ({d}%)'
                },
                legend: {
                    orient: 'vertical',
                    right: '10%',
                    top: 'center',
                    textStyle: {
                        color: '#FFF',
                        fontSize: 12
                    },
                    formatter: function (name) {
                        // 查找对应名称的数据项
                        var data = mockData;
                        var total = 0;
                        var value = 0;
                        for (var i = 0; i < data.length; i++) {
                            total += data[i].value;
                            if (data[i].name === name) {
                                value = data[i].value;
                            }
                        }
                        // 计算百分比并格式化
                        var percent = ((value / total) * 100).toFixed(1) + '%';
                        return name + ' ' + percent;
                    }
                },
                series: [
                    {
                        name: '行为分布',
                        type: 'pie',
                        radius: ['70%', '75%'], // 将圆环调细，内圆60%，外圆75%
                        center: ['35%', '50%'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                            borderRadius: 8,
                            borderColor: 'rgba(0, 28, 53, 0.7)',
                            borderWidth: 2
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 14,
                                fontWeight: 'bold',
                                color: '#FFF'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: mockData,
                        // 在圆环中心显示默认信息
                        label: {
                            normal: {
                                show: true,
                                position: 'center',
                                formatter: '',
                                fontSize: 14,
                                color: '#FFF',
                                fontWeight: 'bold'
                            },
                            emphasis: {
                                show: true,
                                formatter: '{b|{b}}\n\n{percent|{d}%}',
                                fontSize: 16,
                                color: '#FFF',
                                fontWeight: 'bold',
                                rich: {
                                    b: {
                                        fontSize: 16,
                                        color: '#FFF',
                                        fontWeight: 'bold'
                                    },
                                    percent: {
                                        fontSize: 24, // 将百分比字体放大
                                        color: '#FFF',
                                        fontWeight: 'bold'
                                    }
                                }
                            }
                        }
                    }
                ]
            };

            this.pieChart1.setOption(option);
        },
        renderLineChart() {
            const chart = document.getElementById('line-chart');
            this.lineChart = echarts.init(chart);

            const extra = this.parsedExtra;

            // 解析activity_periods成segments数组
            let activity_periods = extra.activity_periods || [];

            // 计算总duration
            const totalDuration = activity_periods.reduce((sum, period) => sum + (period.duration || 0), 0);

            // 转换为segments格式
            this.segments = activity_periods.map(period => {
                const duration = period.duration || 0;
                const percent = totalDuration > 0 ? duration / totalDuration : 0;
                const label = `${period.start_time_formatted || ''}-${period.end_time_formatted || ''}  ${period.region}`;

                return {
                    start_time: period.start_time || 0,
                    end_time: period.end_time || 0,
                    region: period.region || 'other',
                    duration: duration,
                    start_time_formatted: period.start_time_formatted || '00:00',
                    end_time_formatted: period.end_time_formatted || '00:00',
                    label: label,
                    percent: percent
                };
            });

            // 定义颜色
            const colors = ['#4A90E2', '#50E3C2', '#F5A623', '#D0021B'];

            // 定义bar宽度
            const barWidth = 30;

            // 设置图表配置
            const option = {
                tooltip: { show: false },
                grid: {
                    left: 0,
                    top: 0,
                    right: 0,
                    bottom: 0,
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    show: false,
                    min: 0,
                    max: 1
                },
                yAxis: {
                    type: 'category',
                    show: false,
                    data: ['']
                },
                series: []
            };

            this.segments.forEach((seg, index) => {
                const segmentWidth = seg.percent;

                // 创建堆叠的bar系列
                option.series.push({
                    type: 'bar',
                    stack: 'total',
                    data: [{value: segmentWidth}],
                    barWidth: barWidth,
                    barGap: 0,
                    barCategoryGap: 0,
                    itemStyle: { color: colors[index % colors.length] },
                    label: {
                        show: false,
                        position: 'bottom',
                        formatter: seg.label,
                        color: '#FFF',
                        fontSize: 14
                    },
                    animation: false
                });
            });


            this.lineChart.setOption(option);

        },
        handleResize() {
            if (this.pieChart1) {
                this.pieChart1.resize();
            }
            if (this.lineChart) {
                this.lineChart.resize();
            }
        },
        renderImage(){

            const extra = this.parsedExtra;
            let image_path=extra.heatmap.image_path||'';
            this.image_url='https://pk.plckj.cn/admin/proxy/preview?path='+image_path.replace('results','');
          // this.image_url='http://ta.swu.edu.cn:3642/images'+image_path.replace('results','');
        }
    },
}
</script>
<style scoped lang="less">
// 引入通用指标样式
@import '@/assets/css/common-indicator.less';

.indicator-container {
    height: 386px;

    .indicator-content {

        .text-box {
            width: 700px;
        }

        .chart-box {
            display: flex;
            flex-direction: column;

            .video-box {
                display: flex;
                flex-direction: row;
                flex: 1;

                .video {
                    width: 358px;
                    height: 236px;
                    background: #043B6A;

                    img{
                        width: 100%;
                        height: 100%;
                    }
                }

                .pie-chart {
                    flex: 1;
                }
            }

            .line-chart-container {
                position: relative;
                width: 100%;
                height: 60px; /* 增加图表高度，确保箭头可见 */
            }

            .line-chart {
                width: 100%;
                height: 100%;
            }

            /* 箭头样式 */
            .chart-arrow {
                position: absolute;
                top: 50%;
                right: 0;
                transform: translateY(-50%);
                width: 0;
                height: 0;
                border-top: 20px solid transparent;
                border-bottom: 20px solid transparent;
                border-left: 20px solid #F5A623;
                z-index: 10;
            }
        }
    }
}
</style>
